module.exports = __webpack_public_path__ + "img/img_cowboy.ba254a28.png";